import React, { useEffect, useState } from 'react';

import { Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsGet, wsCreate, wsUpdate } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import DetailKardex from './DetailKardex';
import { ConstantPermissions } from 'contexts/useConstant';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import SweetAlert from 'react-bootstrap-sweetalert';
import { wsRemove } from 'services/WService';

const useStyles = makeStyles({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  },
  table: {
    minWidth: 650
  }
});

const defaultData = {
  TaxDate: moment().format('YYYY-MM-DD'),
  DocDate: moment().format('YYYY-MM-DD'),
  JrnlMemo: 'Entrada mercadería'
};

const entity = 'logi/transfer';
const type = 'TR';

export default WithApp(function Transfer(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [notify, showNotify] = useToasty();
  const [alert, setAlert] = useState(null);

  const [productSelecteds, setProductSelecteds] = useState([]);

  const [dataInitial, setDataInitial] = useState({});
  const [dataHeader, setDataHeader] = useState(defaultData);
  const [stateK, setStateK] = useState(false); // estado del kardex (state_migrate)

  const handleChangeHeader = (e) => {
    setDataHeader({ ...dataHeader, [e.target.name]: e.target.value });
  };

  const changeAutocomplete = (field, value, extra) => {
    if (field === 'filler_warehouse_id') {
      delete dataHeader.to_warehouse_id;
      delete dataHeader.to_zone_description;
    }

    setDataHeader({ ...dataHeader, [field]: value, ...extra });
  };

  //#region funciones de traer datas
  const [warehouses, setWarehouses] = useState([]);

  async function listWarehouses() {
    let response = await wsGetAll('logi/warehouse');
    if (response.success) setWarehouses(response.data);
  }
  //#endregion

  async function saveTransfer() {
    let response = await wsCreate(entity, dataHeader);
    if (response.success) {
      window.history.replaceState('', '', `${response.data.id}?type=${type}`);
      getTransfer(response.data.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function updateTransfer() {
    let newData = {};
    for (let key in dataHeader) {
      if (dataInitial[key] != dataHeader[key]) {
        newData[key] = dataHeader[key];
      }
    }

    if (Object.keys(newData).length < 1) return;

    let response = await wsUpdate(entity, dataHeader.id, newData);
    if (response.success) {
      getTransfer(response.data.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function getTransfer(idTransfer) {
    let response = await wsGet('logi/transfer', idTransfer);
    if (response.success) {
      if (response.data.details?.length > 0) {
        response.data.details = response.data.details.map((item) => {
          return {
            ...item,
            quantity: item.Quantity,
            ItemName: item.Dscription,
            SalUnitMsr: item.unitMsr,
            NumInSale: item.NumPerMsr,
            unit_price: item.Price,
            total: parseFloat(item.Quantity || 0) * parseFloat(item.Price || 0)
          };
        });
      }
      setProductSelecteds(response.data.details?.reverse());
      setDataHeader(response.data);
      setDataInitial(response.data);
      setStateK(response.data.state_migrate === 'D' ? false : true);
    }
  }

  async function updateCloseTransfer() {
    let response = await wsUpdate(`${entity}/${dataHeader.id}/close-transfer`, {
      close_return: 'Y',
    });
    if (response.success) {
      showNotify(response.message);
      getTransfer(response.data.id);
    } else {
      showNotify(response.message, 'error');
    }
  }


  async function removeGuia() {
    let response = await wsRemove(`logi/guia-transfer/${dataHeader.guia_transfer_view.id_guia}`, {
      logi_transfer_id: dataHeader.id,
    });
    if (response.success) {
      showNotify(response.message);
      getTransfer(id);
    } else {
      showNotify(response.message, 'error');
    }
  }
  function confirm(action) {
    let titleMessage = "¿Está seguro?";
    if (action === 'remove') {
      titleMessage = "¿Está seguro de remover la transferencia?";
    } else if (action === 'close') {
      titleMessage = "¿Está seguro de cerrar la transferencia?";
    }
    const hideAlert = () => {
      setAlert(null);
    };
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={titleMessage}
        onConfirm={() => {
          if (action === 'remove') {
            removeGuia();
          } else if (action === 'close') {
            updateCloseTransfer();
          }
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  useEffect(() => {
    listWarehouses();
  }, []);

  useEffect(() => {
    if (id) getTransfer(id);
  }, [id]);

  return (
    <>
      <Toasty action={notify} />
      {alert}
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment style={{ color: 'white' }} />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Datos generales de transferencia</h4>
        </CardHeader>
        <CardBody>
          <form
            id="formTransfer"
            onSubmit={(e) => {
              e.preventDefault();
              if (dataHeader.id) {
                updateTransfer();
              } else {
                saveTransfer();
              }
            }}
          >
            <GridContainer>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Fecha contable"
                  type="date"
                  name="TaxDate"
                  fullWidth
                  margin="normal"
                  value={
                    moment(dataHeader.TaxDate).format('YYYY-MM-DD') ||
                    moment().format('YYYY-MM-DD') ||
                    ''
                  }
                  onChange={handleChangeHeader}
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Fecha documento"
                  type="date"
                  name="DocDate"
                  fullWidth
                  margin="normal"
                  value={
                    moment(dataHeader.DocDate).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD')
                  }
                  onChange={handleChangeHeader}
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={3}>
                <Autocomplete
                  key={dataHeader.filler_warehouse_id + warehouses}
                  options={warehouses}
                  disableClearable
                  getOptionLabel={(option) => option.WhsName}
                  defaultValue={
                    warehouses.find((item) => item.id == dataHeader.filler_warehouse_id) ||
                    undefined
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="De almacén" margin="normal" required />
                  )}
                  disabled={stateK}
                  onChange={(e, item) => {
                    changeAutocomplete('filler_warehouse_id', item.id, {
                      filler_zone_description: item.base_zone_description,
                    });
                  }}
                />
              </GridItem>
              <GridItem xs={12} lg={1}>
                <TextField
                  label="De zona"
                  fullWidth
                  margin="normal"
                  value={dataHeader.filler_zone_description || ''}
                  InputProps={{ readOnly: true }}
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={3}>
                <Autocomplete
                  key={dataHeader.filler_warehouse_id + warehouses}
                  options={warehouses.filter((item) => item.id !== dataHeader.filler_warehouse_id)}
                  defaultValue={
                    warehouses.find((item) => item.id == dataHeader.to_warehouse_id) || undefined
                  }
                  disableClearable
                  getOptionLabel={(option) => option.WhsName}
                  renderInput={(params) => (
                    <TextField {...params} label="Almacén destino" margin="normal" required />
                  )}
                  disabled={stateK}
                  onChange={(e, item) =>
                    changeAutocomplete('to_warehouse_id', item.id, {
                      to_zone_description: item.base_zone_description,
                    })
                  }
                />
              </GridItem>
              <GridItem xs={12} lg={1}>
                <TextField
                  label="Zona destino"
                  fullWidth
                  margin="normal"
                  value={dataHeader.to_zone_description || ''}
                  InputProps={{ readOnly: true }}
                  disabled={stateK}
                />
              </GridItem>

              <GridItem xs={12} lg={2}>
                <TextField
                  label="Título"
                  fullWidth
                  name="JrnlMemo"
                  margin="normal"
                  value={dataHeader.JrnlMemo || ''}
                  onChange={handleChangeHeader}
                  inputProps={{ maxLength: 127 }}
                  required
                  disabled={stateK}
                />
              </GridItem>

              <GridItem xs={12} lg={2}>
                <TextField
                  multiline
                  label="Comentario"
                  fullWidth
                  name="Comments"
                  margin="normal"
                  value={dataHeader.Comments || ''}
                  onChange={handleChangeHeader}
                  inputProps={{ maxLength: 127 }}
                  required
                  disabled={stateK}
                />
              </GridItem>

              <GridItem xs={12} lg={2}>
                <TextField
                  label="Almacenero"
                  fullWidth
                  name="U_SYP_ALMACENERO"
                  margin="normal"
                  value={dataHeader.U_SYP_ALMACENERO || ''}
                  onChange={handleChangeHeader}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={2}>
                <TextField
                  label="Solicitante"
                  fullWidth
                  name="U_SYP_SOLICITANTE"
                  margin="normal"
                  value={dataHeader.U_SYP_SOLICITANTE || ''}
                  onChange={handleChangeHeader}
                  required
                  disabled={stateK}
                />
              </GridItem>
              <GridItem xs={12} lg={3}>
                <TextField
                  label="Motivo traslado"
                  fullWidth
                  name="U_SYP_MDMT"
                  margin="normal"
                  value={
                    dataHeader.U_SYP_MDMT === '11' ? 'Salida por transferencia entre almacenes' : 
                      dataHeader.U_SYP_MDMT || 'Salida por transferencia entre almacenes'
                  }
                  disabled
                />
              </GridItem>
            </GridContainer>

            {dataHeader.id ? (
              <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_UPDATE}>
                <Button
                  type="submit"
                  color={props.themeContext.buttonColorWarning}
                  style={{ marginTop: '15px', float: 'right', marginLeft: '10px' }}
                  disabled={stateK}
                >
                  Actualizar
                </Button>
              </AllowedGuard>
            ) : (
              <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_STORE}>
                <Button
                  type="submit"
                  color={props.themeContext.buttonColorSuccess}
                  style={{ marginTop: '15px', float: 'right', marginLeft: '10px' }}
                  disabled={stateK}
                >
                  Guardar
                </Button>
              </AllowedGuard>
            )}

          {dataHeader.state_migrate == 'P' ? (
            <>
              {!!dataHeader.guia_transfer_view?.id_guia ? (
                <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_UPDATE}>
                  <Button
                    color='danger'
                    style={{ marginTop: '15px', float: 'right', marginLeft: '10px' }}
                    onClick={() => confirm('remove')}
                  >
                    Eliminar transferencia de la guía
                  </Button>
                </AllowedGuard>
              ) : undefined
              }
              {dataHeader.close_return == 'N' ? (
                <AllowedGuard permission={ConstantPermissions.LOGI_TRANSFERS_UPDATE}>
                  <Button
                    color="primary"
                    style={{ marginTop: '15px', float: 'right' }}
                    onClick={() => confirm('close')}
                  >
                    Cerrar transferencia
                  </Button>
                </AllowedGuard>
              ) : undefined}
            </>
          ) : undefined}
          </form>
        </CardBody>
      </Card>
      {!!dataHeader.id ? (
        <DetailKardex
          warehouseId={dataHeader.filler_warehouse_id}
          type={type}
          entity={entity}
          dataHeader={dataHeader}
          productSelecteds={productSelecteds}
          setProductSelecteds={setProductSelecteds}
          showNotify={showNotify}
          getKardex={getTransfer}
          stateK={stateK}
          setStateK={setStateK}
        />
      ) : undefined}
    </>
  );
});
